import * as axios from "axios";
import {Base64} from 'js-base64';
import 'react-toastify/dist/ReactToastify.css';

const _baseURL = 'https://life4you-monolith.herokuapp.com/';
// const _baseURL = 'http://localhost:8080/';
const instance = axios.create({
        baseURL: 'https://life4you-monolith.herokuapp.com/'
    }
);
const instanceWithCredentials = axios.create({
        baseURL: _baseURL
    }
);

export const apartmentAPI = {
    async getLatestApartments() {
        return await instance.get('apartment/latest_apartment').then(response => {
            return response.data;
        })
    },
    async getApartmentByUUId(apartment_uuid) {
        return await instance.get('apartment/get/' + apartment_uuid).then(response => {
            return response.data;
        })
    }
};

export const profileApi = {
    async loginUser(email, password, rememberMe) {
        let base64 = Base64.btoa(email + ":" + password);
        return await instanceWithCredentials.get('user/login',
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': "Basic " + base64
                }
            }
        ).then(response => {
                return response.data;
            })

    },
    async registrationUser(first_name, last_name, email, password) {
        let base64 = Base64.btoa(email + ":" + password);
        let body = {
            first_name: first_name,
            last_name: last_name
        };
        return await instanceWithCredentials.post('user/registration', body,
            {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': base64
                }
            }
        )
            .then(response => {
                return response.data;
            })

    }
};



